import { BlotterErrorIcon } from 'components/Blotters/BlotterErrorIcon';
import { BlotterSpinner } from 'components/Blotters/BlotterSpinner';
import { ActivityFilter, defaultAvailableActivities } from 'components/Blotters/Filter/ActivityFilter';
import { FullTextSearch } from 'components/Blotters/Filter/full-text-search';
import { connectFilterComponent, type FilterProps } from 'components/shared/ScheduledRun/Blotter/filter/Filter.connect';
import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

export const ScheduledQuotesBlotterFilterRaw: FC<FilterProps> = ({
  activityFilter,
  quickSearchTerm,
  loading,
  error,
  searchPlaceholder,
  onActivityFilterChanged,
  onQuickSearchTermChanged,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className="w-100 d-flex flex-row flex-wrap flex-md-nowrap align-items-stretch border-top">
      <div className="d-flex px-3 flex-grow-1 align-items-center gap-1">
        <h5 className="h5 lh-1 text-nowrap">
          <FormattedMessage id="scheduledRun.blotter.filter.title" />
        </h5>
        {error && <BlotterErrorIcon message={formatMessage({ id: 'blotter.filter.label.error' })} />}
        <BlotterSpinner className="flex-shrink-0 ms-2 my-auto" hide={!loading} />
      </div>
      <ActivityFilter
        activities={defaultAvailableActivities}
        value={activityFilter}
        onSelect={onActivityFilterChanged}
      />
      <FullTextSearch value={quickSearchTerm} onChange={onQuickSearchTermChanged} placeholder={searchPlaceholder} />
    </div>
  );
};

export const ScheduledQuotesBlotterFilter = connectFilterComponent(ScheduledQuotesBlotterFilterRaw);
